import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, fileUrl } from "@/lib/api";

export const FileUploader = ({ value, onChange, label = "Upload", accept = "image/*,application/pdf", preview = true, testid = "file-uploader" }) => {
    const [busy, setBusy] = useState(false);

    const upload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        const fd = new FormData();
        fd.append("file", file);
        try {
            const r = await api.post("/admin/files", fd, { headers: { "Content-Type": "multipart/form-data" } });
            onChange(r.data.id, r.data);
            toast.success("Uploaded");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Upload failed");
        } finally {
            setBusy(false);
            e.target.value = "";
        }
    };

    return (
        <div>
            <div className="flex items-center gap-3">
                <label className="btn-outline cursor-pointer !py-2" data-testid={testid}>
                    <Upload size={14} /> {busy ? "Uploading…" : label}
                    <input type="file" className="hidden" accept={accept} onChange={upload} disabled={busy} />
                </label>
                {value && (
                    <button type="button" onClick={() => onChange("", null)} className="text-xs text-red-500 hover:underline">
                        Remove
                    </button>
                )}
            </div>
            {preview && value && (
                <div className="mt-2">
                    <img src={fileUrl(value)} alt="" className="h-24 w-24 rounded-lg border border-slate-200 object-cover" onError={(e) => { e.target.style.display = "none"; }} />
                </div>
            )}
        </div>
    );
};

export default FileUploader;
